<template lang="html">

  <div>
    <p>Hej {{user.nickname}}!</p>
    <p>
      Du har drukket {{user.drinkedBeers.length}} ud af {{beers.length}} øl.<br>
      Du kan makére en øl som drukket ved at vælge den gennem <router-link to="/ølkort">ølkortet</router-link>.
    </p>

    <p id="count">{{user.drinkedBeers.length}} / {{beers.length}}</p>

  </div>

</template>

<script>

export default {
  props: {
    user: Object,
    beers: Array,
  },
  methods: {

  }
}
</script>

<style lang="css" scoped>
a{
  font-size: inherit;
  color: inherit;
}
input{
  text-align: center;
  padding: 12px;
}

#id {
  font-size: 6em;
  font-weight: bold;
  margin: 10px;
  line-height: 0.7em;
}

.small{
  font-size: 0.3em;
  font-weight: normal;
  margin: 0;
}

#count {
  margin-top: 20px;
  padding: 20px;
  background-color: var(--primaryColor);
  display: inline-block;
  color: var(--secondaryColor);
  border-radius: 5px;
  font-size: 2em;
  font-weight: bold;
}

</style>
